import(/* webpackMode: "eager" */ "/codebuild/output/src1065430195/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/global-error.tsx");
